// extracted by mini-css-extract-plugin
export default {"bulkLoadPlatePreview":"bulkLoadPlatePreview-m4fuK","plates":"plates-IctIg","gridItem":"gridItem-ndyVb","plateName":"plateName-IBSIn","isNewPill":"isNewPill-v7WqZ"};